export const skipTokenValidationRouteNames = [
  "LoginCallback",
  "Login",
  "Login ID",
  "form-delvium-index", // link identifier should be validated first
  "form-delvium-additional-form-login",
  "form-delvium-additional-form",
  "Footer-content"
];

export const additionalFormRoutes = [
  "form-delvium-index",
  "form-delvium-additional-form-login",
  "form-delvium-additional-form",
  // "Footer-content"
];
